import abstractService from '../abstractService';

const getProductsPublicUrl = 'products/search';
const getProductByIdUrl = 'products/get-one';

export const getProducts = ({ filter, paginationByPageNumbers }) => {
  return abstractService.postRequest(getProductsPublicUrl, null, {
    filter,
    paginationByPageNumbers,
  });
};

export const getProductById = ({ productId }) => {
  const bodyData = {
    productId,
  };
  return abstractService.postRequest(getProductByIdUrl, null, bodyData);
};
